import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, OperationResult, SmBaseService } from '../../core';

@Injectable()
export class SmAccountService extends SmBaseService {
	constructor(http: HttpService) {
		super(http, 'account');
	}

	attachSalesAccount(username: string, password: string): Observable<OperationResult> {
		return this._postAs<OperationResult>('attach', {
			username: username,
			password: password
		});
	}

	deleteSalesAccount(salesAccountId: number): Observable<any> {
		return this._delete(salesAccountId);
	}

	updateSalesAccountsInformation(): Observable<any> {
		return this._post('update', {});
	}

	setMainAccount(salesAccountId: number): Observable<any> {
		return this._post(salesAccountId + '/setmain', {});
	}

	getSalesAccount(): Observable<SalesAccount> {
		return this._getAs<SalesAccount>();
	}
}

export interface SalesAccount {
	id: number;
	accountId: number;
	username: string;
	isMain: boolean;
	isConfirmed: boolean;
	email: string;
	phone: string;
	firstName: string;
	lastName: string;
	company: string;
	address: string;
	city: string;
	postCode: string;
	state: string;
	country: string;
	hasPayUEnabled: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/account.service.ts